import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';

export function searchQuerySuccess(res) {
  return { type: types.SEARCH_QUERY_SUCCESS, res };
}

export function getSecondaryFiltersSuccess(res) {
  return { type: types.GET_SECONDARY_FILTERS_SUCCESS, res };
}

export function loadTrendingSearchesSuccess(content) {
  return { type: types.LOAD_TRENDING_SEARCHES_SUCCESS, content };
}

export function searchQuery(query, spellcheckEnabled, pageNum, primaryFilter, secondaryFilters) {
  let item = {};
  item.query = query;
  item.query_type = `coaching`;
  item.spell_check = spellcheckEnabled;
  item.page_num = pageNum;
  item.primary_filter = primaryFilter;
  
  // If secondary filters are passed then loop through them and add them and to the payload object
  if (secondaryFilters) {
    item = {
      ...item,
      ...secondaryFilters,
    };
  }

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/search-v2`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(searchQuerySuccess(res));
      });
    })
    .catch(response => response.json().then((res) => {
      throw res;
    }));
  };
}

export function getSecondaryFilters(primaryFilter) {
  const item = {};
  item.primary_filter = primaryFilter;

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/search-v2/modifiers`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(getSecondaryFiltersSuccess(res));
      });
    })
    .catch(response => response.json().then((res) => {
      throw res;
    }));
  };
}

export function loadTrendingSearches() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/search-v2/trending`, {
      method: `POST`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        dispatch(loadTrendingSearchesSuccess(res.data));
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}


// WEBPACK FOOTER //
// ./library/app/actions/searchActions.js